import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clip-icon',
  templateUrl: './clip-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClipIconComponent {}
